export default {
  noChannels: '暂无会话',
  selectChannel: '未选中联系人',
  connectFailed: '连接聊天服务失败，请重试',
  sendFailed: '发送失败，请重试',
  inputPlaceholder: '输入消息...',
  send: '发送',
  file: '文件',
  uploadFile: '上传文件',
  retry: '重新连接',
  searchPlaceholder: '搜索联系人或猎头公司名称',
  searchPlaceholder2: '搜索联系人或招聘企业',
  newChat: '发起新会话',
  filterAll: '全部',
  filterUnread: '未读',
  pin: '置顶',
  unpin: '取消置顶',
  markRead: '清除未读',
  markUnread: '标记未读',
  sendTo: '发送',
  cancel: '取消',
  contactTitle: '联系人',
  contactSubtitle: '选择企业后可查看企业里的联系人，点击联系人可开始沟通',
  noCompanies: '暂无企业',
  noPersons: '暂无联系人',
  selectCompanyFirst: '请先选择企业',
  yearsAgo: '{0}年前',
  noCoopHeadhunters: '暂无合作中的猎头公司',
  noCoopEnterprises: '暂无合作中的企业',
  gotIt: '好的',
  headhunterChat: '猎头沟通',
  companyChat: '企业沟通',
  selectCompanyFirst: '选择公司后可查看联系人',
  coopStoppedNoMessage: '已停止合作，不支持发送消息',
}
